export const collections = {
  reportFormats: [
    {
      id: 1,
      name: 'PDF',
    },
    {
      id: 2,
      name: 'DOCX',
    },
  ],
  revisionOptions: [
    {
      id: 1,
      name: 'acceptAllRevisions',
    },
    {
      id: 2,
      name: 'rejectAllRevisions',
    },
  ],
};
